module.exports = __webpack_public_path__ + "static/media/020.f5106169.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/020.jpg
// module id = 493
// module chunks = 0